import { MemberRole } from "@snubes/snubes-types";

export const DEFAULT_MEMBER_ROLE: MemberRole = "MEMBER_REGULAR";
